import { Grid, Space } from "antd";
import { CustomDatePicker } from "components/DatePicker";
import { Prefix } from "components/GraphTable/Prefix";
import { defaultRangePresets } from "constants/RangePickerConstants";
import { endOfDay, isAfter } from "date-fns";
import { RangePickerProps } from "rc-picker";
import { useCallback } from "react";

type DateRange = RangePickerProps<Date>["value"];

const presets = defaultRangePresets({ includeTime: true });

export const RequestDateFilters: React.FC<{
  approvedDateFilter?: DateRange;
  requestedDateFilter?: DateRange;
  onApprovalFilterChange: (value: DateRange) => void;
  onRequestFilterChange: (value: DateRange) => void;
  hideApprovalDateFilter?: boolean;
}> = ({
  approvedDateFilter,
  onApprovalFilterChange,
  onRequestFilterChange,
  requestedDateFilter,
  hideApprovalDateFilter = false,
}) => {
  const timeFormat = "HH:mm";
  const dateTimeFormat = `YYYY-MM-DD ${timeFormat}`;

  const { md } = Grid.useBreakpoint();

  const disableAfterToday = useCallback(
    (current: Date) => current && isAfter(current, endOfDay(new Date())),
    []
  );

  return (
    <Space size="middle" direction={md ? "horizontal" : "vertical"}>
      <Space>
        <Prefix prefix="Requested on" style={{ width: "7em" }} />
        <CustomDatePicker.RangePicker
          allowEmpty={[true, true]}
          disabledDate={disableAfterToday}
          presets={presets}
          onChange={onRequestFilterChange}
          value={requestedDateFilter}
          showTime={{
            format: timeFormat,
          }}
          format={dateTimeFormat}
        />
      </Space>
      {!hideApprovalDateFilter && (
        <Space>
          <Prefix prefix="Approved on" style={{ width: "7em" }} />
          <CustomDatePicker.RangePicker
            allowEmpty={[true, true]}
            disabledDate={disableAfterToday}
            presets={defaultRangePresets({ includeTime: true })}
            onChange={onApprovalFilterChange}
            value={approvedDateFilter}
            showTime={{
              format: timeFormat,
            }}
            format={dateTimeFormat}
          />
        </Space>
      )}
    </Space>
  );
};
